<template>
  <div class="monripay-warp">
    <form action="" method="post" id="payment-form">
      <div class="form-row">
          <div for="card-element" class="form-title" style="padding-top: 12px;">
              -Credit or debit card-
          </div>
          <div id="card-element">
              <!-- A Monri Component will be inserted here. -->
          </div>
          <div>
            <div class="monri-input-row">
              <div class="monri-input-label">E-MAIL</div>
              <div class="monri-input-flex">
                <input type="email" v-model="monriBilling.email" class="monri-input" placeholder="email" />
              </div>
            </div>
          </div>
          <!-- Used to display Component errors. -->
          <div class="monri-errors" id="card-errors" role="alert"></div>
      </div>
      <div class="confirm-btns">
        <button class="btn" style="width: -webkit-fill-available;">Submit Payment</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import monriMixin from "../../mixins/monri"
import { domain } from '../../utils/http'

export default {
  mixins: [monriMixin],
  components: {
  },
  computed: {
    ...mapState(['system', 'cabinet', 'agentOpenId']),
    i18n () {
      return this.$t('paymethod')
    },
    i18nConfirm () {
      return this.$t('confirm')
    }
  },
  data () {
    return {
      authenticityToken: '',
      clientSecret: '',
      monriBilling: {
        address: "N/A",
        fullName: "",
        city: "N/A",
        zip: "71000",
        phone: "N/A",
        country: "BA",
        email: "",
        orderInfo: "preAuth",
        isDev: false
      }
    }
  },
  methods: {
    loadMonriPay () {
      let _this = this
      _this.loadMonriScript(!this.isDev, () => {
        let monri = Monri(_this.authenticityToken);
        let components = monri.components({ "clientSecret": _this.clientSecret });
        let card = components.create('card');

        card.mount('card-element');

        var form = document.getElementById('payment-form');
        form.addEventListener('submit', function (event) {
            _this.$loading(true)
            event.preventDefault();
            _this.monriBilling.fullName = _this.monriBilling.email
            monri.confirmPayment(card, _this.monriBilling).then(function (result) {
                _this.$loading(false)
                if (result.error) {
                    // Inform the customer that there was an error.
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                } else {
                  _this.handlePaymentResult(result.result)
                }
            });
        });
        this.$nextTick(() => {
          _this.isMonriCard = true
          // card.mount('card-element');
        })
      })
    },
    handlePaymentResult(paymentResult) {
      // Handle PaymentResult
      if (paymentResult.status === 'approved') {
        if (this.system === 'android') {
          window.open(`${domain}/#/result?status=approved`)
        } else {
          window.location.href = `${domain}/#/result?status=approved`
        }
      } else {
        console.log('pay err')
      }
    }
  },
  created () {
    console.log('路由数据===', this.$route.query)
    this.authenticityToken = this.$route.query.authenticityToken
    this.clientSecret = this.$route.query.clientSecret
    this.isDev = this.$route.query.liveFlag === "0"
    this.loadMonriPay()
  }
}
</script>

<style lang="less" scoped>
.monripay-warp {
  height: 100vh;
  background-color: #fff;
  overflow-y: scroll;
  .form-row {
    padding: 0 32px;
  }
  .form-title {
    width: 100%;
    font-size: 28px;
    padding: 30px 0 20px;
    text-align: center;
  }
  .monri-input-row {
    flex: 1;
    margin-bottom: 20Px;
    .monri-input-label {
      font-size: 10Px;
      text-transform: uppercase;
      width: 100%;
      margin-bottom: 10Px;
      letter-spacing: 1.5px;
      color: #929397;
      white-space: pre-wrap;
    }
    .monri-input {
      flex: 1;
      border: none;
      box-shadow: none;
      border-bottom: 1Px solid #eee;
      border-radius: 0;
      color: #3e3e3e;
      letter-spacing: 1Px;
      padding: 6Px 5Px;
      // width: calc(100% - 10Px);
    }
    .monri-input::placeholder {
      color: #929397 !important;
      opacity: .5
    }
  }
  .monri-input-flex {
    display: flex;
  }
  .monri-errors {
    font-size: 10Px;
    color: #fc0d1b;
  }
}
</style>
